import { useContext } from 'react'

import { FeatureToggleContext } from './FeatureToggleContext'
import type { FeatureToggleContextType } from './types'

export function useFeatureToggle(): FeatureToggleContextType {
  const context = useContext(FeatureToggleContext)

  if (!context) {
    throw new Error('useFeatureToggle must be used within FeatureToggleProvider')
  }

  return context
}
